import { N53 } from "./CustomerGroupSalesWithGrowth/N53";
import { N27 } from "./SalesByChannelLastYearVSActualSales/N27";

export const RegionGrowthPerformance = {
  "sections": [
    N53,
    N27
  ]
}